<template>
  <v-main>
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :fetcher="fetchData"
    >
      <!-- Customiza a mensagem se não temos CCs selecionados -->
      <template v-slot:when-empty="{ filter, loadStatus }">
        <OJumbo
          info
          v-if="filter.costCenterIds == null || filter.costCenterIds.length < 1"
        >
          Selecione ao menos um Centro de Custo para buscar.
        </OJumbo>

        <OJumbo loading v-else-if="loadStatus == 'not-loaded'">
          Carregando dados...
        </OJumbo>

        <OJumbo question v-else>
          Não foram encontrados dados para o filtro/período informados.
        </OJumbo>
      </template>

      <!-- Customiza o botão de export excel para não exigir
           de datas (pois sempre existe o strMonth) mas exigir
           costCenterIds -->
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn icon @click="checkDownload" title="Exportar para Excel">
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { go } from '@/models'
import moment from 'moment'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { saveBlobAs } from 'oderon-vue/utils'

export default {
  pageTitle: 'Medição de Centro de Custo',
  components: {
    GenericReport
  },
  data() {
    return {
      reportSpec: {
        code: 'measureV2',
        title: 'Medição de Centro de Custo',
        apiBase: '/measure-v2',
        filters: [
          { type: 'CostCenter' },
          { type: 'CostCenterPeriod', size: 'md' },
          { type: 'CostCenterFormat', prefix: 'format', defVal: 'merged' }
        ]
      }
    }
  },
  methods: {
    // Retorna os parâmetros para a API, mas não valida os obrigatórios.
    computeApiParams(filter) {
      let { costCenterIds, format, vars } = filter
      let { fromDate, untilDate, strMonth } = filter.costCenterPeriod || {}
      if (strMonth == null) strMonth = moment().format('YYYY-MM')

      if (costCenterIds != null && costCenterIds.length < 1)
        costCenterIds = null

      return {
        costCenterIds,
        fromDate,
        untilDate,
        strMonth,
        format,
        vars
      }
    },

    async fetchData(apiParams) {
      const newParams = this.computeApiParams(apiParams)
      if (newParams.costCenterIds == null) {
        return { count: 0, rows: [] }
      } else if ( apiParams.format == 'merged' ) {
        // NB: Não envia limit e offset pois não queremos paginação
        return await go.get('/measure-v2/grid', newParams)
      } else {
        newParams.month = newParams.strMonth
        return await go.get('/cost-centers/multiple-reports', newParams)
      }
    },

    async checkDownload() {
      const filter = this.$refs.report.apiParams
      const newParams = this.computeApiParams(filter)
      if (newParams.costCenterIds == null) {
        this.$info({
          message: `
            <p>Para baixar o arquivo Excel deste relatório,
            é necessário selecionar pelo menos um centro de
            custo.</p>
          `
        })
      } else if ( newParams.format == 'merged' ) {
        const res = await go.download('/measure-v2/grid/download', newParams)
        saveBlobAs(res.blob, res.filename)
      } else {
        newParams.month = newParams.strMonth
        const res = await go.download('/cost-centers/multiple-reports/download', newParams)
        saveBlobAs(res.blob, res.filename)
      }
    }
  }
}
</script>

<style></style>
